import { Sparkle } from "lucide-react";
import Reveal from "@/components/Reveal";

const SectionHeader = ({ eyebrow, title, subtitle, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : ""}>
    <p
      className={`flex items-center gap-2 text-sm font-semibold uppercase tracking-widest text-[#D4AF37] ${
        align === "center" ? "justify-center" : ""
      }`}
    >
      <Sparkle className="h-4 w-4" fill="currentColor" aria-hidden="true" />
      {eyebrow}
    </p>
    <h2 className="mt-3 text-3xl font-medium tracking-tight text-[#2C2A35] sm:text-4xl">{title}</h2>
    {subtitle && <p className="mt-4 max-w-2xl text-base leading-relaxed text-[#6B6776] sm:text-lg">{subtitle}</p>}
  </Reveal>
);

export default SectionHeader;
